<template>
    <div class="module-center">
      <div class="content">
        <slot></slot>
        <!-- <slot name="painSpot"></slot>
        <slot name="title"></slot>
        <slot name="showImg"></slot> -->
      </div>
    </div>
</template>
<script>
export default {
   data() {
      return {
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.module-center {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content {
  width: 1200px;
}
</style>
